import BathroomCabinetRefacing from "./bathroom-cabinet-refacing.svg";
import KitchenCabinetRefacing from "./kitchen-cabinet-refacing.svg";
import OtherCabinetRefacing from "./other-cabinet-refacing.svg";

const icons = {
  "bathroom-cabinet-refacing": BathroomCabinetRefacing,
  "kitchen-cabinet-refacing": KitchenCabinetRefacing,
  "other-cabinet-refacing": OtherCabinetRefacing,
};

export default icons;
